// @ts-nocheck
import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess<CartLineCollectionModel | void>,
    CartLineCollectionModel,
    CartLineCollectionModel
>;

export const StoreExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult); // Store Custom Code
};
replaceInChain(chain, ExecuteOnSuccessCallback, StoreExecuteOnSuccessCallback);
